import { render, staticRenderFns } from "./PropertiesHomesAndUnits.vue?vue&type=template&id=b609bdea&scoped=true"
import script from "./PropertiesHomesAndUnits.vue?vue&type=script&lang=ts"
export * from "./PropertiesHomesAndUnits.vue?vue&type=script&lang=ts"
import style0 from "./PropertiesHomesAndUnits.vue?vue&type=style&index=0&id=b609bdea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b609bdea",
  null
  
)

export default component.exports